import DealerAddParams from "../../../../../../common/services/dealer/add/dealer-add-params";
import DealerAddByRailyFormData from "./types/dealer-add-by-raily-form-data";

const create = (formData: DealerAddByRailyFormData): DealerAddParams => {
  return {
    firstName: formData.firstName,
    lastName: formData.lastName,
    email: formData.email,
    username: formData.username,
    password: formData.password,
    phoneNumber: formData.phoneNumber,
    alternativePhoneNumber: formData.alternativePhoneNumber,
    taxiCorporationUuid: formData.taxiCorporationUuid,
  };
};

const dealerAddByRailyParamsFactory = {
  create,
};

export default dealerAddByRailyParamsFactory;
